<template>
  <div v-if="shouldShowModal">
    <div class="container-novidade">
      <button
        @mouseover="mostrarModal"
        @mouseleave="esconderModal"
        :id="'tooltip-target-' + index"
        class="button"
      >
        {{ labelText }}
      </button>

      <div v-if="isModalVisible " :class="['modal', 'modal-' + index]">
        <span>{{ messageContent }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalNovidade",
  props: {
    message: {
      type: String,
      default: "Esta é uma mensagem de novidade padrão.",
    },
    labelText: {
      type: String,
      default: "?",
    },
    index: {
      type: Number,
      default: 1, 
    },
      dataInicio: { 
      type: String, // Formato esperado: 'YYYY-MM-DD'
      default: null,
    },
    dataFim: {
      type: String, // Formato esperado: 'YYYY-MM-DD'
      default: null
  },
},
  data() {
    return {
      isModalVisible: false, 
    };
  },
  computed: {
    messageContent() {
      return this.message;
    },
  shouldShowModal() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let startDate = null;
    if (this.dataInicio) {
      startDate = new Date(this.dataInicio + 'T00:00:00');
    }

    let endDate = null;
    if (this.dataFim) {
      endDate = new Date(this.dataFim + 'T23:59:59');
    }

    const isAfterStartDate = !startDate || today >= startDate;
    const isBeforeEndDate = !endDate || today <= endDate;

    //console.log('Today (00:00:00):', today);
    //console.log('Start Date:', startDate);
    //console.log('End Date (23:59:59):', endDate);
    //console.log('isAfterStartDate:', isAfterStartDate);
    //console.log('isBeforeEndDate:', isBeforeEndDate);
    //console.log('Should Show Modal:', isAfterStartDate && isBeforeEndDate);

    return isAfterStartDate && isBeforeEndDate;
  },
},
  methods: {
    mostrarModal() {
      this.isModalVisible = true;
    },
    esconderModal() {
      this.isModalVisible = false;
    },
  },
};
</script>

<style scoped>

.tooltip {
  display: flex;
  width: max-content;
  margin: 1rem 0 1rem 0;
}

.button {
  margin: 0.3rem 0.7rem 0 0;
  font-size: 0.9rem;
  background-color: #ffa900;
  border: none;
  border-radius: 0.3rem;
  padding: 0.15rem 0.4rem;
  cursor: pointer;
}

.button:hover {
  box-shadow: 0px 0px 0px;
  padding: 0.15rem 0.4rem;
  font-size: 0.9rem;
  background-color: #edf2ee;
}

.container-novidade {
  position: relative; 
  display: inline-block; 
}

.modal {
  display: block;
  width: 12rem;
  z-index: 1000;
  position: absolute;
  max-width: 16rem;
  font-size: 0.8rem;
  background-color: #edf2ee;
  box-shadow: 3px 5px 5px #ffa900;
  padding: 0.8rem 1rem;
  border-radius: 0.5rem;
 
}

.modal span {
  font-weight: bold;
}

/* Posicionamento dos modais para diferentes tamanhos de tela */
@media screen and (min-width: 320px) and (max-width: 425px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;
  }
}

@media screen and (min-width: 426px) and (max-width: 1024px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5vh;
  }
  .modal-2 {
    left: -2.5rem;
    top: 5vh;
  }
  .modal-3 {
    left: -5.5rem;
    top: 5vh;
  }
  .modal-4 {
    left: -9rem;
    top: 5vh;
  }
}

@media screen and (min-width: 1441px) and (max-width: 2560px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5vh;
  }
  .modal-2 {
    left: -2.5rem;
    top: 5vh;
  }
  .modal-3 {
    left: -5.5rem;
    top: 5vh;
  }
  .modal-4 {
    left: -9rem;
    top: 5vh;
  }
}

/* Estilo para alto contraste */
.alto-contraste .button {
  background-color: #115810;
  color: white;
}

.alto-contraste .modal {
  background-color: #0d2b10;
  color: white;
  border: 1px solid #ffa900;
}
</style>